import { RequestConfig } from '@/interface'

const BASE_URL = 'https://api.igeshui.com/'
const PRIFIX = `${BASE_URL}api/v3/tax/`

const policyConfig: RequestConfig = {
  // 本月生效状态
  effectiveLawOpenState: {
    url: `${PRIFIX}taxLaw/effectiveLawOpenState`,
    method: 'get'
  },
  // 全部政策列表
  allPolicyList: {
    url: `${PRIFIX}search/globalSearch`,
    method: 'post'
  },
  // 本月生效政策列表
  monthlPolicyList: {
    url: `${PRIFIX}taxLaw/effectiveLaw/v2.5.0`,
    method: 'post'
  },
  // 政策类型
  policyType: {
    url: `${BASE_URL}api/v1/dict/getDictByParent/china_tax_type`,
    method: 'get'
  },
  // 减免税分类
  getDeratePolicyClassify: {
    url: `${PRIFIX}derate/policy/getDeratePolicyClassify`,
    method: 'get'
  },
  // 减免税列表
  getDeratePolicyList: {
    url: `${PRIFIX}derate/policy/getDeratePolicyList`,
    method: 'post'
  },
  // 全部政策详情和本月政策详情
  getChinaTaxLawInfo: {
    url: `${BASE_URL}api/v1/expert/getChinaTaxLawInfo`,
    method: 'get'
  },
  // 减免税政策详情
  getDeratePolicyInfoById: {
    url: `${BASE_URL}api/v3/tax/derate/policy/getDeratePolicyInfoById`,
    method: 'get'
  }
}
export default policyConfig
